import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import OptimizeImagesService from 'services/OptimizeImages.service';

import styles from './CaseBig.module.scss';

export default class CaseBigComponent extends Component {
  static defaultProps = {
    className: ''
  };
  static propTypes = {
    caseStudy: PropTypes.object.isRequired
  };

  render() {
    const {
      className,
      caseStudy: {
        title,
        publicationDate,
        link,
        photo,
        company: { logo }
      }
    } = this.props;

    return (
      <div className={`${styles.CaseBig} ${className}`}>
        <div
          className={styles.Image}
          style={{
            backgroundImage: `url(${OptimizeImagesService.adjustImageSize(
              photo.url
            )})`
          }}
        />
        <div className={styles.Info}>
          <h3 className={styles.Title}>
            {link.isValid() ? (
              <a
                href={link.href}
                target="_blank"
                rel="noopener noreferrer nofollow"
              >
                {title}
              </a>
            ) : (
              title
            )}
          </h3>
          <div className={styles.Data}>
            <p className={styles.Date}>
              {moment(publicationDate).format('DD.MM.YYYY')}
            </p>
            <p className={styles.URL}>{link.origin}</p>
            <div className={styles.IMGWrapper}>
              <img
                src={OptimizeImagesService.adjustImageSize(logo)}
                alt="logo"
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/SimpleCaseStudy/components/CaseBig/CaseBig.js